import { render } from "./Chapter.vue?vue&type=template&id=3af176ae"
import script from "./Chapter.vue?vue&type=script&lang=js"
export * from "./Chapter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__